var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{class:'text-sm pt-2'},[_vm._v(" "+_vm._s(_vm.$t('form.aucune_garantie.aucune_garantie'))+" ")]),_vm._v(" "),_c('div',{staticClass:"shadow border border-gray-200 text-red-600 font-bold p-6 my-4 my-rounded bg-white"},[_vm._v(" "+_vm._s(_vm.$t('form.aucune_garantie.demande_hors_garantie_non_pris_en_charge'))+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17d89960","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/processes/cards/shop/NoWarrantyCard.vue
// module id = null
// module chunks = 